import type { ReactNode } from 'react';

import { css } from '@sorare/css';

import { IconButton } from '#src/atoms/buttons/IconButton/index.tsx';
import { iconStickyNote } from '#src/atoms/icons/system/iconStickyNote.ts';
import { Centered } from '#src/atoms/layout/Centered/index.tsx';

const centeredTop = css`
  align-items: start;
`;

type Props = {
  transactionsPath: string;
  children: ReactNode;
};

export const CurrencyBalanceHeader = ({
  transactionsPath,
  children,
}: Props) => (
  <Centered
    className={centeredTop}
    right={
      <IconButton
        size="small"
        color="quaternary"
        to={transactionsPath}
        icon={iconStickyNote}
      />
    }
  >
    {children}
  </Centered>
);
